import { render, staticRenderFns } from "./PatientCoverages.vue?vue&type=template&id=20303784"
import script from "./PatientCoverages.vue?vue&type=script&lang=js"
export * from "./PatientCoverages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports